import * as React from 'react';
import PlayersApi from "../../api/Players";
import MatchesApi from "../../api/Matches";
import TeamsApi from "../../api/Teams";
import * as moment from 'moment';
import './details.css';

export default class TeamDetails extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            team: {},
            players: [],
            matches: [],
            rivals: [],
            teamsTable: []
        }   
    }

    componentWillMount(){
        let state = {...this.state};
        TeamsApi.get(this.props.match.params.value).then(r =>{
            state.team = r.data.response;
            return PlayersApi.getByTeam(this.props.match.params.value);
        }).then(r => {
            state.players = r.data.response;
            return MatchesApi.getFiltered(`team=${this.props.match.params.value}&sheet=all`);
        }).then(r => {
            state.matches = r.data.response.matches;
            return TeamsApi.get();
        }).then(r => {
            state.rivals = r.data.response;
            return TeamsApi.getTeamLeagueStats(state.team.id, state.team.league_id);
        }).then(r => {
            state.teamsTable = r.data.response;
            state.teamsTable.sort((a, b) => a.points > b.points ? -1 : a.points < b.points ? 1 : a.goals > b.goals ? -1 : 1);
            this.setState(state);
        }).catch(err => console.log(err));
    }

    getRivalName(id){
        let t = this.state.rivals.find(r => r.id === id)
        console.log(t)
        return  t ? t.team : "Equipo eliminado";
    }

    render(){
        return (
            <div>
                <div className="card">
                    <div className="card-content">
                        <div className="columns is-multiline">
                            <div className="column is-3">
                                <img src="http://ramico.com.mx/assets/logo_default_team.png" />
                            </div>
                            <div className="column is-9 is-3rem">
                                <h1>{this.state.team.team}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="columns is-multiline">
                    <div className="column is-5">
                        <div className="card">
                            <div className="card-content">
                                <table className="table is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Nombre</th>
                                            <th>TA</th>
                                            <th>TAM</th>
                                            <th>TR</th>
                                            <th>JJ</th>
                                            <th>Goles</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.players.map(p => {
                                            return (
                                                <tr key={p.id}>
                                                    <td>{p.number}</td>
                                                    <td>{p.name}</td>
                                                    <td>{p.bc}</td>
                                                    <td>{p.yc}</td>
                                                    <td>{p.rc}</td>
                                                    <td>{p.gp}</td>
                                                    <td>{p.goals}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <div className="column is-6">
                        <div className="card">
                            <div className="card-content">
                                <table className="table is-fullwidth">
                                    <thead>
                                    <tr>
                                        <th>Equipo</th>
                                        <th>JJ</th>
                                        <th>JG</th>
                                        <th>JE</th>
                                        <th>JP</th>
                                        <th>SO+</th>
                                        <th>Pts</th>
                                        <th>Goleo</th>
                                        <th>Posición</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.teamsTable.map((tt, i) => {
                                        return (
                                            <tr key={tt.team} className={tt.team === this.state.team.id ? 'is-selected' : ''}>
                                                <td>{tt.team_name}</td>
                                                <td>{tt.wins + tt.losses + tt.draws}</td>
                                                <td>{tt.wins}</td>
                                                <td>{tt.draws}</td>
                                                <td>{tt.losses}</td>
                                                <td>{tt.so_win}</td>
                                                <td>{tt.points}</td>
                                                <td>{`${tt.goals > 0 ? '+' : ""}${tt.goals}`}</td>
                                                <td>{i+1}º</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br/>
                        <div className="card">
                            <div className="card-content">
                                <table className="table is-fullwidth">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Rival</th>
                                        <th>Fecha</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                     {this.state.matches && this.state.matches.map(m => {
                                        return (
                                            <tr className={m.status==1 ? "no_played" : ''} key={m.id}>
                                                <td>{m.goals1} vs {m.goals2}</td>
                                                <td className={(m.goals1<m.goals2 || m.so_win==m.team2_id) ? "is-winner" : ''}>{m.team1_id === this.state.team.id ? this.getRivalName(m.team2_id) : this.getRivalName(m.team1_id)}</td>
                                                <td>{moment(m.day).format('DD/MM/YYYY HH:mm')}</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/team/Details.js